import {
  alertsActions,
  showOverlayActions,
  workdeskFilterActions,
  workdeskTicketsActions,
} from '.';
import getErrorMessage from '../../utils/getErrorMessage';
import { assignTicketConstants } from '../constants';
import { userDataSelector } from '../selectors';
import { ticketGroupTableSelectedIdsListSelector } from '../selectors/ticket-group-table.selector';
import { ticketIdSelector } from '../selectors/ticket.selector';
import { assignTicketsService } from 'store/services/assign-tickets.service';
import { unassignTicketsService } from 'store/services/unassign-tickets.service';
import { manualSiActions } from './manual-si.actions';
import { ticketActions } from './ticket.action';
import { TimeTrackingStatus } from 'components/common/DurationPanel';

const postAssignOfSelectedTicketIds = () => {
  return (dispatch, getState) => {
    const ticketIds = ticketGroupTableSelectedIdsListSelector(
      getState(),
    );
    if (ticketIds && ticketIds.length) {
      dispatch(postManyAssignTickets(ticketIds));
    } else {
      console.warn(`no ticketIds selected`);
    }
  };
};

const postUnassignOfSelectedTicketIds = () => {
  return (dispatch, getState) => {
    const ticketIds = ticketGroupTableSelectedIdsListSelector(
      getState(),
    );
    dispatch(
      showOverlayActions.show('Note', {
        ticketId: ticketIds,
        status: TimeTrackingStatus.unassigned,
        durationInSeconds: 0,
        handleOnClick: (ticketIds) => {
          if (ticketIds && ticketIds.length) {
            dispatch(postManyUnassignTickets(ticketIds));
          } else {
            console.warn(`no ticketIds selected`);
          }
        },
      }),
    );
  };
};

const postUnassignTicket = (
  ticketId: string,
  saveBeforeUnassign = false,
) => {
  return async (dispatch) => {
    if (saveBeforeUnassign) {
      await dispatch(ticketActions.postAutosaveCurrentFormTicket());
    }
    dispatch(postManyUnassignTickets([ticketId]));
  };
};

const postAssignTicket = (ticketId: string) => {
  return (dispatch) => {
    dispatch(postManyAssignTickets([ticketId]));
  };
};

const postAssignTicketWithAutoMarkSI = (ticketId: string) => {
  return async (dispatch) => {
    await dispatch(manualSiActions.postManualSi(ticketId, true));
    dispatch(postAssignTicket(ticketId));
  };
};

const postManyUnassignTickets = (ticketIds: string[]) => {
  const post = (ticketIds: string[]) => {
    return {
      type: assignTicketConstants.UNASSIGN_TICKET_POST,
      payload: { ticketIds },
    };
  };
  const failure = (ticketIds, error) => {
    return {
      type: assignTicketConstants.UNASSIGN_TICKET_ERROR,
      payload: {
        ticketIds,
        error,
      },
    };
  };
  const success = (ticketIds: string[]) => {
    return {
      type: assignTicketConstants.UNASSIGN_TICKET_SUCCESS,
      payload: { ticketIds },
    };
  };
  return (dispatch, getState) => {
    dispatch(post(ticketIds));
    unassignTicketsService
      .postWorkdeskUnassignTickets(ticketIds)
      .then((data) => {
        console.debug('unassign to :', data);
        const dataArray = Array.isArray(data) ? data : [data];
        dispatch(success(dataArray.map((d) => d.id)));
        dispatch(workdeskTicketsActions.updateTickets(dataArray));

        const curTicketId = ticketIdSelector(getState());
        if (curTicketId && ticketIds.includes(curTicketId)) {
          const newTicket = dataArray.find(
            (ticket) => ticket.id === curTicketId,
          );
          if (newTicket && !newTicket.assigneeId) {
            dispatch(ticketActions.removeTicketAssignee());
            dispatch(
              workdeskFilterActions.toggleSelectedStatusIfIsNotCurrent(
                newTicket.status,
              ),
            );

            // TODO: update other detail
          } else if (!newTicket) {
            console.error(
              `couldn't find ticket ${curTicketId} in the assign response for some reason`,
            );
          }
        }
      })
      .catch((error) => {
        const errorMessage = getErrorMessage(error);
        dispatch(failure(ticketIds, errorMessage));
        dispatch(alertsActions.error(errorMessage));
      });
  };
};

const postManyAssignTickets = (ticketIds: string[]) => {
  const post = (ticketIds) => {
    return {
      type: assignTicketConstants.ASSIGNTICKET_POST,
      payload: { ticketIds },
    };
  };
  const failure = (ticketIds, error) => {
    return {
      type: assignTicketConstants.ASSIGNTICKET_ERROR,
      payload: {
        ticketIds,
        error,
      },
    };
  };
  const success = (ticketIds: string[]) => {
    return {
      type: assignTicketConstants.ASSIGNTICKET_SUCCESS,
      payload: { ticketIds },
    };
  };
  return (dispatch, getState) => {
    dispatch(post(ticketIds));
    assignTicketsService
      .postWorkdeskAssignTickets(ticketIds)
      .then((data) => {
        const dataArray = !Array.isArray(data) ? [data] : data;
        dispatch(success(dataArray.map((d) => d.id)));
        // what if we are on the main page and ticket's status is not the same as the loadParams?
        dispatch(workdeskTicketsActions.updateTickets(dataArray));
        // if ids is current ticket
        const curTicketId = ticketIdSelector(getState());
        if (curTicketId && ticketIds.includes(curTicketId)) {
          const newTicket = dataArray.find(
            (ticket) => ticket.id === curTicketId,
          );
          const userData = userDataSelector(getState());
          if (
            newTicket &&
            userData &&
            newTicket.assigneeId === userData.id
          ) {
            dispatch(
              ticketActions.updateTicketAssigneeToMe(
                newTicket.senderId,
              ),
            );
            dispatch(
              workdeskFilterActions.toggleSelectedStatusIfIsNotCurrent(
                newTicket.status,
              ),
            );
            // TODO: update other detail
            // find overlaped fields between after assign (first of array) and load (data.ticket)
            // userId, status, senderId
          } else if (newTicket && !newTicket.assigneeId) {
            console.error(`newTicket.assigneeId is missing`);
          } else if (!newTicket) {
            console.error(
              `couldn't find ticket ${curTicketId} in the assign response for some reason`,
            );
          } else if (!userData) {
            console.error(`userData is missing`);
          } else {
            console.error(
              `newTicket.assigneeId ${newTicket.assigneeId} is different from user's id ${userData.id}`,
            );
          }
        }
      })
      .catch((error) => {
        console.error(error);
        const errorMessage = getErrorMessage(error);
        dispatch(failure(ticketIds, errorMessage));
        dispatch(alertsActions.error(errorMessage));
      });
  };
};

export const assignUnassignActions = {
  postUnassignTicket,
  postAssignTicket,
  postManyAssignTickets,
  postManyUnassignTickets,
  postUnassignOfSelectedTicketIds,
  postAssignOfSelectedTicketIds,
  postAssignTicketWithAutoMarkSI,
};
